import React, { Component } from 'react'

import MaterialIcon, { colorPalette } from 'material-icons-react';
import { Row, Col } from "react-bootstrap";
import OgaTree from "../../components/OgaTree/OgaTree";
import { Typeahead } from "react-bootstrap-typeahead";
import * as customData from 'assets/js/nodes.json';
import * as d3 from "d3-3";

import API_URL from 'utils/HttpClient/apiRest'
import Loader from "../../components/elements/loader/Loader";
import TreeForm from "./TreeForm/TreeForm";
import { SCREEN_THRESHOLD } from "../../global/constants";

import TreeNewTeam from "views/Tree/TreeNewTeam/TreeNewTeam";

import { connect } from 'react-redux';
import { isPosibleAddNewTeam, addNewTeam } from 'reducers/newteam/newteamActions';
import ConfirmModal from "components/ConfirmModal/ConfirmModal";

class TreeView extends Component {

    isDesktop;
    searchNameList = [];
    constructor(props) {
        super(props)
        this.state = {
            loaded: false,
            selectedSearch: null,
            treeData: null,
            showAddNewTeam: false,            
            showNewTeamModal: false,
            loadingNewTeam: false
        }
        this.isDesktop = window.innerWidth > SCREEN_THRESHOLD
    }

    componentWillMount() {
        this.loadTree();
        this.loadButtonAddNewTeam();
    }

    loadButtonAddNewTeam(){
        let promise = new Promise((resolve, reject) => {
            this.props.isPosibleAddNewTeam(resolve, reject);
        });

        promise.then((res) => {
            this.setState({ showAddNewTeam: res });
        }, () => {

        });
    }

    loadTree() {
        d3.json(`${API_URL}oga/saleorder/tree?isSale`)
            .header("authorization", localStorage.getItem('access_token'))
            .post((error, data) => {
                if (error) {
                    this.setState({ loaded: true, });
                    throw error;
                }
                this.onDataReceived(data);
            });
    }

    onDataReceived = (data) => {
        this.populateSearchNames(data);
        this.setState({
            loaded: true,
            treeData: data,
            currentSelection: null
        })
    };

    populateSearchNames = (child) => {
        if (child.name) {
            this.searchNameList.push({ id: child.id, name: child.name });
        }
        if (child.children) {
            let len = child.children.length;
            if (len > 0) {
                for (let i = 0; i < len; i++) {
                    this.populateSearchNames(child.children[i]);
                }
            }
        }
    }

    componentDidMount() {

    }

    onUserSelected = (selected) => {
        this.setState({ selectedSearch: selected });
    }

    onSelectionChange = (user) => {
        this.setState({
            loaded: false,
        });

        this.setState({
            loaded: true,
            currentSelection: user
        });
    }

    showModalAddNewTeam = () => {
        this.setState({
            showNewTeamModal: true
        });
    }

    addNewTeam = () => {
        this.setState({ loadingNewTeam: true });
        let promise = new Promise((resolve, reject) => {
            this.props.addNewTeam(resolve, reject);
        });

        promise.then(() => {
            this.setState({
                showNewTeamModal: false,
                loadingNewTeam: false,
                loaded: false,
                showAddNewTeam: false
            });
            this.loadTree();
        }, () => {
            this.setState({ showNewTeamModal: false, loadingNewTeam: false });
        });
    }

    render() {
        let loaded = this.state.loaded;
        let desktopClass = !this.isDesktop ? 'top-margin' : '';
        let treeContainer2TopMargin = this.isDesktop ? 'desktop-top-margin' : '';
        let selectedUser = this.state.currentSelection;
        let hide = !loaded ? { display: "none" } : {};
        return (
            <div className="tree localTree fade-show">
                <div>
                    <div className={`tree-container-0 ${desktopClass}`}>

                        <div ref="container_1" style={hide} >
                            <OgaTree
                                isSale={false}
                                fullTree
                                searchname={this.state.selectedSearch}
                                treeData={this.state.treeData}
                                onSelectionChange={this.onSelectionChange} />
                        </div>

                        <div ref="container_2" className={`tree-container-2 ${treeContainer2TopMargin}`} >
                            <div className="main-container container">
                                <Row>
                                    <Col md={12}>
                                        <h1 className="header">Mi red</h1>
                                    </Col>

                                    <Col md={4} style={{ pointerEvents: "all" }}>
                                        <Typeahead
                                            className="tree-search"
                                            placeholder="&rarr; Nombre de Afiliado"
                                            labelKey={option => `${option.name}`}
                                            onChange={this.onUserSelected}
                                            selected={this.state.selectedSearch}
                                            options={this.searchNameList}
                                            defaultValue={null} />
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    loaded ? null :
                        <div className="tree-container-0">
                            <div className="centered">
                                <Loader show={true} />
                            </div>
                        </div>
                }
                <div className="tree-container-0 z-index" style={{ pointerEvents: "none" }}>
                    <div className="w-100 vh-100" style={{ pointerEvents: "none" }}>
                        <TreeForm loaded={loaded} selectedUser={selectedUser} />
                    </div>
                </div>

                {this.state.showAddNewTeam &&
                    <div className="tree-container-0 z-index" style={{ pointerEvents: "none" }}>
                        <div className="w-100 vh-100" style={{ pointerEvents: "none" }}>
                            <TreeNewTeam
                                addNewTeam={() => this.showModalAddNewTeam()}
                            />
                        </div>
                    </div>
                }

                <ConfirmModal
                    show={this.state.showNewTeamModal}
                    loading={this.state.loadingNewTeam}
                    title="Agregar nuevo equipo"
                    message="¿Está seguro de agregar un nuevo equipo de tres nodos?"
                    annul={() => this.addNewTeam()}
                    onHide={() => this.setState({ showNewTeamModal: false })}
                />


            </div>
        )
    }
}
export default connect(null, { isPosibleAddNewTeam, addNewTeam })(TreeView);


// WEBPACK FOOTER //
// ./src/views/Tree/TreeView.jsx